/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Registration_Url_DescInputs */



/**
* | output |
* | --- |
* | "where players sign up when it isn't Archon — Archon's own sign-up turns off, and you import the list as a CSV" |
*
* @param {Og_Cfg_Registration_Url_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_registration_url_desc = /** @type {((inputs?: Og_Cfg_Registration_Url_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Registration_Url_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("où les joueurs s'inscrivent quand ce n'est pas Archon — les inscriptions propres à Archon se désactivent, et vous importez la liste en CSV")
	if (locale === "es") return /** @type {LocalizedString} */ ("dónde se inscriben los jugadores cuando no es Archon — la inscripción propia de Archon se desactiva, y la lista se importa como CSV")
	if (locale === "pt") return /** @type {LocalizedString} */ ("onde os jogadores se inscrevem quando não é pelo Archon — a inscrição do próprio Archon se desativa, e você importa a lista como CSV")
	if (locale === "it") return /** @type {LocalizedString} */ ("dove si iscrivono i giocatori quando non è Archon — l'iscrizione di Archon si disattiva, e l'elenco si importa come CSV")
	return /** @type {LocalizedString} */ ("where players sign up when it isn't Archon — Archon's own sign-up turns off, and you import the list as a CSV")
});